import { render } from "./showImage2.vue?vue&type=template&id=298b7e65&scoped=true"
import script from "./showImage2.vue?vue&type=script&lang=js"
export * from "./showImage2.vue?vue&type=script&lang=js"

import "./showImage2.vue?vue&type=style&index=0&id=298b7e65&scoped=true&lang=css"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-298b7e65"]])

export default __exports__